"use client";

import { IPages, IUserData } from "@/types";
import { useProfileAnalytics } from "./useProfileAnalytics";

export default function RenderV2ClientAnalytics({
    account,
    page,
}: {
    account: IUserData;
    page?: IPages;
}) {
    useProfileAnalytics({
        user: account,
        pageId: page?.id || null,
    });

    return null;
}
